import { useEffect, useState } from 'react';

/**
 * The phone breakpoint, shared by the shell (drawer menu, bottom tab bar), the theme hook and
 * the Prospect Tracker phone layout. Matches the `max-width: 767px` blocks in the shell CSS.
 */
export const MOBILE_QUERY = '(max-width: 767px)';

function matches(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(MOBILE_QUERY).matches
    : false;
}

export function useMobileViewport(): boolean {
  const [isMobile, setIsMobile] = useState(matches);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const query = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setIsMobile(query.matches);
    onChange();
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
